import script from "./GiftMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftMessage.vue?vue&type=script&setup=true&lang=js"

import "./GiftMessage.vue?vue&type=style&index=0&id=130f2a74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-130f2a74"]])

export default __exports__